import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Auth } from '@aws-amplify/auth';
import { catchError, from, Observable, of, switchMap } from 'rxjs';

@Injectable()
export class ApiAuthInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return from(Auth.currentSession()).pipe(
      switchMap((auth) => {
        const idToken = auth.getIdToken().getJwtToken();
        const requestWithAuth = request.clone({
          setHeaders: {
            Authorization: `Bearer ${idToken}`,
          },
        });
        return of(requestWithAuth);
      }),
      catchError(() => {
        return of(request);
      }),
      switchMap((finalRequest) => next.handle(finalRequest))
    );
  }
}
